import React, { Component } from 'react';
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBIcon, MDBRow, MDBCol, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import axios from 'axios';
import ConfigData from '../Components/config';
import AppDataTable from '../Components/AppDataTable';

export default class ShowSJCODERubrong extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            TYPEMANAGE: null,
            TYPE_ID: null,
            SJCODE: null,
            OLDTYPE_ID: null,
            OLDSJCODE: null,
            array_ShowSJCODERubrong: [],
            array_TYPERubrong: [],
        }
        this.modal_open = this.modal_open.bind(this);
        this.modal_close = this.modal_close.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        axios.get(ConfigData.SERVER_URL + "FrontEND_Tabian/petition/ShowSJCODERUBRONG").then((res) => {
            if (res.data.length !== 0) {
                var i = 0;
                while (i < res.data.SJCODERUBRONG.length) {
                    res.data.SJCODERUBRONG[i]["Index"] = i + 1;
                    res.data.SJCODERUBRONG[i]["Statusfill"] = <>
                        <button className="btn btn-warning btn-sm" value={res.data.SJCODERUBRONG[i].TYPE + "," + res.data.SJCODERUBRONG[i].SJCODE} onClick={this.modal_open}><MDBIcon icon="edit" /> แก้ไข</button>
                    </>
                    i++
                }
                this.setState({
                    array_ShowSJCODERubrong: {
                        columns: [
                            { label: '#', field: 'Index', },
                            { label: 'ประเภทวิชา', field: 'TYPE_NAME', },
                            { label: 'รหัสวิชา', field: 'SJCODE', },
                            { label: 'ชื่อวิชา', field: 'SUBJNAME', },
                            { label: 'จัดการ', field: 'Statusfill', },
                        ],
                        rows: res.data.SJCODERUBRONG
                    }
                })
                this.setState({ array_TYPERubrong: res.data.TYPERUBRONG })
            }
        })
    }

    modal_open(event) {
        event.preventDefault();
        if (event.target.value !== "") {
            var splitvalue = event.target.value.split(",")
            this.setState({ TYPE_ID: splitvalue[0] })
            this.setState({ SJCODE: splitvalue[1] })
            this.setState({ OLDTYPE_ID: splitvalue[0] })
            this.setState({ OLDSJCODE: splitvalue[1] })
            this.setState({ TYPEMANAGE: "edit" })
        } else {
            this.setState({ TYPEMANAGE: "add" })
        }
        this.setState({ modal: true })
    }

    modal_close(event) {
        event.preventDefault();
        this.setState({ TYPEMANAGE: null })
        this.setState({ TYPE_ID: null })
        this.setState({ SJCODE: null })
        this.setState({ modal: false })
        this.setState({ OLDTYPE_ID: null })
        this.setState({ OLDSJCODE: null })
    }

    handleChange(event) {
        event.preventDefault();
        this.setState({ [event.target.name]: event.target.value })
    }

    handleSubmit(event) {
        event.preventDefault();
        let bodydata = {
            TYPEMANAGE: this.state.TYPEMANAGE,
            TYPE_ID: this.state.TYPE_ID,
            SJCODE: this.state.SJCODE,
            OLDTYPE_ID: this.state.OLDTYPE_ID,
            OLDSJCODE: this.state.OLDSJCODE,
        }
        axios.post(ConfigData.SERVER_URL + "FrontEND_Tabian/petition/InsertSJCODERUBRONG", bodydata).then((res) => {
            if (res.data === 1) {
                this.setState({ TYPEMANAGE: null })
                this.setState({ TYPE_ID: null })
                this.setState({ SJCODE: null })
                this.setState({ modal: false })
                this.setState({ OLDTYPE_ID: null })
                this.setState({ OLDSJCODE: null })
                window.location.reload()
            }
        })
    }

    render() {
        return (<>
            <span className="white-text mt-3" style={{ fontSize: '22px' }}>รายวิชาที่ต้องการรับรอง</span><span className="white-text mt-3" style={{ fontSize: '16px' }}> มหาวิทยาลัยราชภัฏกำแพงเพชร</span>

            <MDBRow>
                <MDBCol lg="12" md="12" sm="12">
                    <MDBCard className="mt-3">
                        <MDBCardBody>
                            <MDBCardTitle className="h5">
                                รายวิชาที่ต้องการรับรอง <button className="btn btn-success btn-md" onClick={this.modal_open}><MDBIcon icon="plus" /> เพิ่มรายวิชา</button>
                            </MDBCardTitle>
                            <MDBCardText>
                                <AppDataTable data={this.state.array_ShowSJCODERubrong} />
                            </MDBCardText>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>

            <MDBModal isOpen={this.state.modal} toggle={this.modal_close} centered>
                <MDBModalHeader toggle={this.modal_close}>รายวิชาที่ต้องการรับรอง</MDBModalHeader>
                <form onSubmit={this.handleSubmit}>
                    <MDBModalBody>

                        <div className="form-outline mt-2">
                            <label className="form-label" for="TYPE_ID">สถานะนักศึกษา</label>
                            <select class="form-control" id="TYPE_ID" name="TYPE_ID" onChange={this.handleChange} required>
                                <option value="" hidden>---ระบุสถานะนักศึกษา---</option>
                                {this.state.array_TYPERubrong.map((data) => {
                                    return data.TYPE_ID === this.state.TYPE_ID ? <>
                                        <option value={data.TYPE_ID} selected>{data.TYPE_NAME}</option>
                                    </> : <>
                                        <option value={data.TYPE_ID}>{data.TYPE_NAME}</option>
                                    </>
                                })}
                            </select>
                        </div>

                        <div className="form-outline mt-2">
                            <label className="form-label" for="SJCODE">รายละเอียดคำร้องและเหตุผลประกอบภาษาไทย</label>
                            <input type="text" className="form-control" id="SJCODE" name="SJCODE" value={this.state.SJCODE} onChange={this.handleChange} required />
                        </div>

                    </MDBModalBody>
                    <MDBModalFooter>
                        <button type="submit" className="btn btn-primary btn-md" disabled={this.state.TYPE_ID && this.state.SJCODE ? false : true}>บันทึกข้อมูล</button>
                        <button type="button" className="btn btn-danger btn-md" onClick={this.modal_close}>ยกเลิก</button>
                    </MDBModalFooter>
                </form>
            </MDBModal>
        </>);
    }
}